export { default } from './es/icons/AlertOutlined';